import { render, staticRenderFns } from "./niveisdeacesso.vue?vue&type=template&id=7235dc9d&"
import script from "./niveisdeacesso.vue?vue&type=script&lang=js&"
export * from "./niveisdeacesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports